import styled from 'styled-components'

interface SidebarWrapperProps {
  sidebar: boolean
}

export const SidebarWrapper = styled.aside<SidebarWrapperProps>`
  user-select: none;
  border-radius: 1.2rem;
  position: fixed;
  transition: all 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  overflow-x: visible;
  height: 100vh;

  ::-webkit-scrollbar {
    display: none;
    height: none;
  }
  -ms-overflow-style: none;
  ::-webkit-scrollbar-track {
    display: none;
  }
  scrollbar-width: none;
  transition: all 0.5s ease-in-out;

  @media (max-width: 1024px) {
    display: none;
  }
`

export const SidebarBtnContainer = styled.div`
  transition: all 0.5s ease-in-out;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  flex: 1;
  height: 100%;
  min-height: 1;
  padding: 1rem;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    display: none;
    height: none;
  }
  z-index: -1;
`
interface SideBarBtnProps {
  readonly active: boolean
  readonly open: boolean
}

export const SidebarBtn = styled.div<SideBarBtnProps>`
  width: ${(props) => (props.open ? '200px' : '45px')};
  transition: all 1s ease;
  display: flex;
  font-weight: ${({ active }) => (active ? '500' : '400')};
  align-items: center;
  background: ${(props) => props.theme.sidebarOption};
  border: ${(props) => (!props.active ? '1px solid #ffffff' : '0.2px solid #969696')};
  color: ${(props) => props.theme.colorGray};
  cursor: pointer;
  text-transform: capitalize;
  border-radius: 0.6rem;
  padding: 0 1.2rem;
  height: 45px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  /* Rectangle 22752 */
  box-sizing: border-box;
  justify-content: ${(props) => (props.open ? 'space-between' : 'center')};

  /* transition: all 1 ease; */
  span {
    transition: all 0.6s ease-in-out;
  }
  :hover {
    span {
      transform: rotate(-20deg);
      transition: all 0.6s ease-in-out;
    }
  }

  span {
    margin-bottom: -0.3rem;
  }

  svg {
    * {
      fill: ${(props) => props.theme.colorGray}!important;
    }
  }

  .chev {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s ease;
    transform: ${(props) => (props.active ? 'rotate(180deg)' : 'rotate(0deg)')};
    svg {
      * {
        fill: none !important;
        stroke: ${(props) => (props.active ? 'white' : props.theme.colorGray)}!important;
      }
    }
  }
`

export const SideBarList = styled.div`
  transition: all 0.5s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 10px;
  list-style: none;
  animation: suboptions-animation 0.1s ease-in forwards;
  transform-origin: top;
  transform: scaleY(0);
  animation-delay: 0.2s;

  @keyframes suboptions-animation {
    0% {
      transform: scaleY(0);
    }
    100% {
      transform: scaleY(100%);
    }
  }
`

interface SideBarOptionProps {
  readonly active?: boolean
  readonly open?: boolean
  readonly subOption?: boolean
}

export const SubOptionsContainer = styled.div`
  width: 100px;
  height: 100px;
  background-color: red;
`

export const SideBarOption = styled.div<SideBarOptionProps>`
  ${(props) => props.theme.container};
  position: relative;
  overflow: hidden;
  min-width: ${(props) => (props.open ? '200px' : '45px')};
  max-width: ${(props) => (props.open ? '200px' : '45px')};
  transition: all 0.5s ease-in-out;
  min-height: 45px;
  border-radius: 10px;
  color: ${(props) => props.theme.colorGray};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  gap: 1rem;
  ${(props) => props.active && 'background-color:#ff9900;'}
  cursor: pointer;

  .icon-container {
    height: 20px;
    color: ${(props) => (props.active ? '#1E1E1E' : props.theme.textColor)};

    svg {
      flex-shrink: 0;
      * {
        flex-shrink: 0;
      }
    }
  }

  p {
    white-space: nowrap;
    text-align: start;
    width: 100%;
    color: ${(props) => (props.active ? '#000000' : props.theme.textColor)};
    text-transform: capitalize;
  }

  &:hover {
    background-color: ${(props) => props.theme.colorOrangeHover};
    p {
      color: white;
    }
    .icon-container {
      color: white;
      height: 20px;
    }
  }

  ${(props) => props.open && '.chevron{transition:.2s ease; transform:rotate(180deg)}'}
`
export const SidebarFooter = styled.div`
  background-color: #f5f5f5;
  font-weight: 400;
  position: fixed;
  bottom: 6%;
  font-size: 0.8rem;
  color: ${(props) => props.theme.colorOrange};
  padding: 1rem 1rem;
  border-radius: 0.3rem;
  display: flex;
  align-items: center;
  gap: 0.4rem;
`
export const LogoContainer = styled.div`
  position: relative;
  width: auto;
  margin: 1rem 0;
  padding: 1rem;

  .aim-i,
  .aim-m {
    position: absolute;
    opacity: 0;
    top: 1rem;
  }

  .aim-i {
    animation: aim-i-animation forwards 0.3s ease;
  }

  .aim-m {
    animation: aim-m-animation forwards 0.3s ease;
    animation-delay: 0.2s;
  }

  @keyframes aim-i-animation {
    from {
      opacity: 0;
      left: 0;
    }

    to {
      opacity: 1;
      left: 4.5rem;
    }
  }
  @keyframes aim-m-animation {
    from {
      opacity: 0;
      left: 0;
    }

    to {
      opacity: 1;
      left: 5.5rem;
    }
  }
`
